<template>
    <div>Single product child template. Never used.</div>
</template>